import Properties from "./seller/Properties";

const Seller = () => {
	return <>
		<Properties />
	</>;
};

export default Seller;
